module.exports = __webpack_public_path__ + "927d53b0ab4606043777e9e17d5fcb49.glb";